// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12.0009 0.833984L18.3729 4.65718L17.3439 6.37216L17.0009 6.16636V8.00017H7.0009V6.16636L6.6579 6.37216L5.62891 4.65718L12.0009 0.833984ZM11 3.99805V6.00195H13.0039V3.99805H11Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 10H2V22H8V15H16V22H22V10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10 17V22H14V17H10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-building-2-filled')
export default class Building2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'building-2-filled',
    }
  }
}
